import React from "react";

import YuqueMarkdown from "../yuque_markdown";

/**
 * 本地默认渲染器 —— **本地实现只需要替换这一个文件**
 *
 * 契约：{ render(markdown: string, React): ReactNode }
 * - 返回 React 元素（不返回 HTML 字符串）
 * - 样式由实现自己负责：import 自己的 less / 注入 <style> / 内联 style 都可以；
 *   如果希望「连样式都在这一个文件里」，在返回节点里带一个 <style> 即可，插槽不关心样式来源
 * - 不需要关心页面布局：外层容器由 MarkdownRenderer 提供
 *
 * 想换成本地另一套解析 / 组件时，把本文件替换成同样导出 { render } 的实现即可；
 * 想换成线上脚本时，改 ./config.js 的 rendererUrl，不用动这个文件。
 */
const defaultRenderer = {
  id: "yuque",
  render(markdown) {
    return <YuqueMarkdown markdown={markdown} />;
  },
};

export default defaultRenderer;
